import { $api } from '../y/api';
import { YId, YTimeString } from '../y/types';
import { CBooking, CBookingId, CBookingPart, CBookingPartId, CBookingPartStatus } from './c-booking';
import { TTicket } from './t-ticket';

export interface CBookingPartView extends CBooking {
    parts: CBookingPart[];
}

export interface CBookingListView extends CBooking {
    user_first_name: string;
    user_last_name: string;
    user_email: string;
}

export interface CBookingAdminView {
    id: CBookingId;
    part_id: CBookingPartId;
    is_test: boolean;
    session_id: YId;
    session_time: YTimeString;
    event_id: YId;
    event_name: string;
    city_id: YId;
    producer_id: YId;
    user_id: YId;
    user_first_name: string;
    user_last_name: string;
    user_email: string;
    number: string;
    quantity: number;
    status: CBookingPartStatus;
    is_late_cancel: boolean;
    is_priority: boolean;
    updated_at: YTimeString
    created_at: YTimeString;
}

export function cBookingSendTickets(booking_id: CBookingId) {
    return $api.POST<CBooking>(`c/booking/${booking_id}/send_tickets`);
}

export function cBookingAddFreeTickets(booking_id: YId, quantity: number) {
    return $api.POST<CBookingAdminView>(`c/booking/${booking_id}/add_free_tickets`, { quantity });
}

export function cBookingForceUnbook(booking_id: CBookingId) {
    return $api.POST(`c/booking/${booking_id}/force_unbook`);
}

export function cBookingPartPrioritize(booking_id: CBookingPartId) {
    return $api.POST(`c/booking_part/${booking_id}/prioritize`);
}

export function cBookingPartStandbyReserve(booking_id: CBookingPartId) {
    return $api.POST(`c/booking_part/${booking_id}/standby_reserve`);
}

export function cBookingNoShow(booking_id: CBookingId) {
    return $api.POST(`c/booking/${booking_id}/add_no_show`);
}

export function cBookingsGroup(bookings: CBooking[]) {
    return $api.POST<YId>('c/bookings/group', { bookings: bookings.map(b => b.id) }).then(id => {
        for(const b of bookings) {
            b.group_id = id;
        }
    });
}

export function cBookingsUnGroup(bookings: CBooking[]) {
    return $api.POST('c/bookings/ungroup', { bookings: bookings.map(b => b.id) }).then(() => {
        for(const b of bookings) {
            b.group_id = undefined;
        }
    });
}

interface SessionBookingsResponse {
    bookings: CBookingListView[];
    tickets: TTicket[];
    booking_list_token: string;
}

export function cBookingsBySession(session_id: YId) {
    return $api.GET<SessionBookingsResponse>(`c/bookings/list_view/by_session/${session_id}`);
}

export function cBookingsByEvent(event_id: YId) {
    return $api.GET<CBookingListView[]>(`c/bookings/list_view/by_event/${event_id}`);
}

let bookings_admin_view_promise: Promise<CBookingAdminView[]> | undefined;
export function cBookingsAdminView(reload?: boolean) {
    if(!bookings_admin_view_promise || reload) {
        bookings_admin_view_promise = $api.GET<CBookingAdminView[]>('c/bookings/admin_view');
    }

    return bookings_admin_view_promise;
}

export function cBookingsAdminViewByUser(user_id: YId) {
    return $api.GET<CBookingAdminView[]>(`c/bookings/admin_view/by_user/${user_id}`);
}

export function cBookingCreate(user_id: YId, event_id: YId, session_id: YId, amount: number, is_free: boolean, allow_overbook: boolean) {
    return $api.POST('booking', { user: user_id, event: event_id, session: session_id, amount: amount, is_free: is_free, allow_overbook: allow_overbook });
}

